import { FETCH_OVERVIEW_DATA_INIT, FETCH_OVERVIEW_DATA_SUCCESS, FETCH_OVERVIEW_DATA_FAIL } from './constants';

const initialState = {
    overviewData: null,
    loading: false,
    error: null,
  };

  const crmOverviewReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_OVERVIEW_DATA_INIT:
        return { ...state, loading: true, error: null };
      case FETCH_OVERVIEW_DATA_SUCCESS:
        return { ...state, loading: false, overviewData: action.payload };
      case FETCH_OVERVIEW_DATA_FAIL:
        return { ...state, loading: false, error: action.error };
      default:
        return state;
    }
  };
  
  export default crmOverviewReducer;